import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  isScreenBelow1004,
  isScreenBelow800,
  isScreenBelow502,
} from 'store/common/settings/breakpoint/selectors';
import CrossSell from 'bricks/CrossSell';
import { CROSSSELL_MEDIUM, CROSSSELL_SMALL, CROSSSELL_TINY } from 'bricks/CrossSell/constants';
import { RECENTLY_VIEWED_CONTAINER_ID } from 'store/widgets/recentlyViewedProducts/constants';
import {
  getRecentlyViewedProductsHeadline,
  getRecentlyViewedProductsList,
  getRecentlyViewedActiveButtonText,
  getRecentlyViewedButtonText,
} from 'store/widgets/recentlyViewedProducts/selectors';
import {
  addToBasketRecentlyViewed,
  recentlyViewedDOMLoaded,
  switchToRecentlyViewedCard,
  recentlyViewedSwitch,
} from 'store/widgets/recentlyViewedProducts/actions';

/**
 * CrossSell Compact & Flat
 */
class RecentlyViewedLayout extends React.Component {
  componentDidMount() {
    this.props.onMount(this.props.list);
  }

  /**
   * Adjusting props based on given 'size' prop
   */
  sizeToProps = () => {
    const { size } = this.props;

    switch (size) {
      case CROSSSELL_TINY:
        return {
          framesPerSlide: 1,
          isFlat: false,
        };
      case CROSSSELL_SMALL:
        return {
          framesPerSlide: 2,
          isFlat: false,
        };
      case CROSSSELL_MEDIUM:
        return {
          framesPerSlide: 3,
          isFlat: false,
        };
      default:
        return {
          framesPerSlide: 4,
          isFlat: false,
        };
    }
  };

  render() {
    const { containerId, src, ...otherProps } = this.props;
    return (
      <div id={containerId}>
        <CrossSell src={src} {...otherProps} {...this.sizeToProps()} />
      </div>
    );
  }
}

RecentlyViewedLayout.propTypes = {
  headline: PropTypes.string, // inheritedProp
  containerId: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.oneOf([CROSSSELL_TINY, CROSSSELL_SMALL, CROSSSELL_MEDIUM]), // size field applies various adjustments
  list: PropTypes.arrayOf(
    PropTypes.shape({
      oldPrice: PropTypes.null || PropTypes.number,
      hasOldPrice: PropTypes.bool,
      isTariff: PropTypes.bool,
      slug: PropTypes.string,
      productId: PropTypes.number,
      name: PropTypes.string,
      article: PropTypes.string,
      detailsSlugOrId: PropTypes.string,
      gtmPrice: PropTypes.bool,
      price: PropTypes.number,
      remain: PropTypes.number,
      maxQuantity: PropTypes.number,
      collectionId: PropTypes.number,
      collectionNameSingular: PropTypes.string,
      brandName: PropTypes.string,
      promotionId: PropTypes.null || PropTypes.number,
      scaleString: PropTypes.null || PropTypes.string,
      isPreorder: PropTypes.bool,
      scale: PropTypes.object,
      image: PropTypes.shape({
        weight: PropTypes.null || PropTypes.number,
        id: PropTypes.string,
        imageUrl: PropTypes.string,
        thumbUrl: PropTypes.string,
        widgetImageUrl: PropTypes.string,
        shopProductId: 0,
      }),
    }),
  ), // inherited prop
  cardButtonText: PropTypes.string, // inheritedProp
  activeCardButtonText: PropTypes.string, // inheritedProp
  onProductClick: PropTypes.func, // inheritedProp
  onMount: PropTypes.func,
  isCrossSellPopupOpen: PropTypes.bool,
  onAddToBasket: PropTypes.func, // inheritedProp
  onSwitchFrame: PropTypes.func,
};

RecentlyViewedLayout.defaultProps = {
  containerId: RECENTLY_VIEWED_CONTAINER_ID,
  className: 'recentlyViewed',
};

/**
 * local selector for resolution,
 * isolated into a function to keep mapStateToProps clean
 */
const getAdaptivitySize = (state) => {
  if (isScreenBelow502(state)) return CROSSSELL_TINY;
  if (isScreenBelow800(state)) return CROSSSELL_SMALL;
  if (isScreenBelow1004(state)) return CROSSSELL_MEDIUM;
  return null;
};

const mapStateToProps = (state) => ({
  headline: getRecentlyViewedProductsHeadline(state),
  list: getRecentlyViewedProductsList(state),
  size: getAdaptivitySize(state),
  activeCardButtonText: getRecentlyViewedActiveButtonText(state),
  cardButtonText: getRecentlyViewedButtonText(state),
});

const mapDispatchToProps = {
  onAddToBasket: addToBasketRecentlyViewed,
  onProductClick: switchToRecentlyViewedCard,
  onSwitchFrame: recentlyViewedSwitch,
  onMount: recentlyViewedDOMLoaded,
};

const RecentlyViewedWidget = connect(mapStateToProps, mapDispatchToProps)(RecentlyViewedLayout);

RecentlyViewedWidget.propTypes = {};

export default RecentlyViewedWidget;
